import React from 'react';
import Button from './Button';

function EmptyState({ children }) {
  return <div className="text-center my-16 max-w-md m-auto">{children}</div>;
}

function Icon({ icon: Icon }) {
  return <Icon className="mx-auto h-10 w-10 text-black mb-4 block" />;
}

function Title({ children }) {
  return <h3 className="text-2xl font-semibold text-black mb-2">{children}</h3>;
}

function Subtitle({ children }) {
  return <p className="text-gray-700">{children}</p>;
}

function Action({ children, ...props }) {
  return (
    <div className="mt-4">
      <Button type="button" appearance="primary" {...props}>
        {children}
      </Button>
    </div>
  );
}

EmptyState.Icon = Icon;
EmptyState.Title = Title;
EmptyState.Subtitle = Subtitle;
EmptyState.Action = Action;

export default EmptyState;
